<template>
  <div class="confirm">
    <div class="bg_white mt12 pt16 pb16 boxs1">
      <h1 class="complete_text ab">手続きが完了しました。</h1>
      <div class="complete_btn_wrap">
        お支払い方法、配送住所、配送時間の変更は、<br>
        定期購入画面から別途お手続きください。
      </div>
      <div class="mt16">
        <button type="button" name="button" @click="closeWebView()" onClick="android.close()" class="back btn_delete">閉じる</button>
      </div>
    </div>
    <div class="bg_white mt12 pt16 pb16">
      <div class="mb20" v-for="(value, l) in cartItems" :key="l">
        <h2 class="content_title">購入BC</h2>
        <div class="pl16 pr16 mt24">
          <h3 class="nowBC rb c5a bdb">BC：<span class="bc_number rb">{{ value.bcNo }}</span></h3>
        </div>
        <div class="select_item bdb" v-for="(item, m) in value.bcItemList" :key="m">
          <div class="image_wrap">
            <div class="select_image">
              <img :src="imagePath + item.product.imagePath" :alt="item.product.productName" v-on:error="imageError" :data-noimage="imagePath + item.product.noImagePath">
            </div>
            <p class="select_item--title ab c5a">{{ item.product.productName }}</p>
          </div>
          <div class="select_contents">
            <div class="subscription_wrap bdb">
              <h2 class="sub_title ab c5a">定期購入</h2>
              <div class="sub_count">
                <p class="count ab c5a">数量</p>
                <p class="number rb c5a">{{ item.orderCount }}</p>
              </div>
            </div>
            <div class="kodomo_text ab">こども基金：<span class="">{{ (item.childFund) ? '支援する' : '支援しない' }}</span></div>
            <div class="select_price">
              <p class="item_price rm c5a"><span class="yen ab">￥</span>{{ item.childFund ? ((item.product.price * item.orderCount) + (100 * item.orderCount)).toLocaleString() : (item.product.price * item.orderCount).toLocaleString() }}</p>
              <p class="item_point rm c5a"><span class="point_text ab">ポイント：</span>{{ (item.product.point * item.orderCount).toLocaleString() }}<span class="point ab">pt</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/config/config'
import { mapGetters } from 'vuex';
import close from '@/model/closeWebView'

export default {
  data() {
    return {
      imagePath: Config.APIURL,
      cartItems: [],
      totalPrice: 0,
      totalPoint: 0
    }
  },
  methods: {
    closeWebView() {
      this.storageClear();
      close.closeWebView();
    },
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    itemList() {
      let items = JSON.parse(localStorage.getItem('recommendationRepeatItemList'));

      if (items) {
        for (var i = 0; i < items.length; i++) {
          var cartItem = {
            bcNo: items[i].bcNo,
            bcItemList: []
          };
          var bcItemList = items[i].bcItemList;

          for (var j = 0; j < bcItemList.length; j++) {
            var itemList = bcItemList[j].itemList;

            for (var k = 0; k < itemList.length; k++) {
              if (itemList[k].repeatOrder) {
                cartItem.bcItemList.push(itemList[k]);
              }
            }
          }
          this.cartItems.push(cartItem);
        }
      }

      if(this.cartItems.length != 0) {
        for (var i = 0; i < this.cartItems.length; i++) {
          for (var j = 0; j < this.cartItems[i].bcItemList.length; j++) {
            var bcItem = this.cartItems[i].bcItemList[j];
            let totalPrice = bcItem.product.price * bcItem.orderCount;
            let totalPoint = bcItem.product.point * bcItem.orderCount;
            this.totalPrice = this.totalPrice + totalPrice;
            this.totalPoint = this.totalPoint + totalPoint;
            if (bcItem.childFund) {
              this.totalPrice = this.totalPrice + (100 * bcItem.orderCount);
            }
          }
        }
      }
    },
    storageClear() {
      try {
        // localStorage クリーンアップの統一処理
        const keysToRemove = [
          'userDetail',
          'recommendationSimulationResponse',
          'recommendationRepeatItemList',
          'recommendationExistRepeatItem',
          'addressSelectNumber',
          'recommendationPurchaseSettings',
        ];

        // バッチ削除処理
        keysToRemove.forEach(key => {
          try {
            localStorage.removeItem(key);
          } catch (error) {
            console.warn(`localStorageのキー削除エラー: ${key}`, error);
          }
        });

        // Vuex状態のリセット
        this.$store.commit('setSubscriptionDenyCreditDeliveryFlag', null);

        // 推奨商品関連の状態もクリア
        this.$store.commit('setRecommendationRecommendProductMap', {});
        this.$store.commit('setRecommendationSimulationResult', null);
        this.$store.commit('setRecommendationMultiBcOrderData', {});

        console.debug('ストレージのクリアが正常に完了しました');
      } catch (error) {
        console.error('ストレージのクリア中にエラーが発生しました:', error);
      }
    },
  },
  computed: mapGetters(['checkSelectRepeatOrder']),
  created () {
    this.itemList();
  },
};
</script>

<style lang="css" scoped>
.sameWithBc {
  color: red;
  font-size: 13px;
}
.complete_text {
  font-size: 20px;
  text-align: center;
}
.complete_btn_wrap {
  font-size: 14px;
  margin-top: 16px;
  text-align: center;
}
.complete_btn {
  margin-top: 30px;
}

.select_item {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px 15px 30px;
}
.image_wrap {
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 33%;
}
.month_item {
  display: flex;
  margin-top: 16px;
}
.select_item--title {
  font-size: 12px;
  margin-top: 5px;
}

.subscription_wrap {
  display: flex;
  justify-content: space-between;
}
.subscription_wrap .sub_title {
  font-size: 16px;
}
.subscription_wrap .sub_count {
  align-items: center;
  display: flex;
}

.subscription_wrap .count {
  font-size: 12px;
}

.subscription_wrap .number {
  font-size: 20px;
  margin-left: 27px;
}
.kodomo_text {
  display: flex;
  font-size: 12px;
  justify-content: flex-end;
  margin-top: 18px;
}
.select_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 11px;
}

.content_title {
  margin-top: 12px;
  width: 221px;
}

.selsct_bc {
  font-size: 20px;
  margin-top: 9px;
  padding-left: 8px;
  position: relative;
}
.selsct_bc::before {
  background-color: #4FCCD4;
  bottom: 0;
  content: '';
  height: 25px;
  left: 0;
  margin: auto;
  position: absolute;
  top: 0;
  width: 4px;
}

.item_price {
  font-size: 26px;
}

.item_point {
  font-size: 16px;
}

.select_contents {
  margin-top: 60px;
  width: 59%;
}

.content_title {
  width: 140px;
}
.content_title.sum {
  width: 120px;
}
.content_title.delyvery_flag {
  width: 260px;
}

.bc_wrap .bc_number {
  font-size: 20px;
  margin-top: 15px;
  padding-bottom: 5px;
}
.bc_wrap .item_wrap {
  -ms-align-items: flex-start;
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
.bc_wrap .item_contents {
  width: 31%;
}

.bc_wrap .item_image {
  margin: auto;
  width: 90%;
}

.bc_wrap .item_title {
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
}

.bc_wrap .contents_detail {
  width: 57.4%;
}

.bc_wrap .count_wrap {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.bc_wrap .month {
  font-size: 24px;
}

.bc_wrap .month_text {
  font-size: 16px;
  margin-left: 2px;
}

/* .bc_wrap .count {
  font-size: 26px;
} */

/* .bc_wrap .count_text {
  font-size: 14px;
  margin-right: 19px;
} */

.bc_wrap .child_wrap {
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-top: 22px;
}

.bc_wrap .price_wrap {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-top: 25px;
}

.bc_wrap .price {
  font-size: 26px;
}

.bc_wrap .yen {
  font-size: 20px;
}
.bc_wrap .point {
  font-size: 16px;
}
.bc_wrap .point_text {
  font-size: 12px;
}
.bc_wrap .pt {
  font-size: 14px;
}

.confirm_wrap {
  align-items: flex-end;
  /* border-bottom: 1px solid #C9C9C9; */
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-bottom: 8px;
}
.edit {
  letter-spacing: 7.5px;
  margin: 0;
  text-indent: 7.5px;
}
.confirm_data {
  color: #5a5a5a;
  font-size: 16px;
  line-height: 1;
}
.data_wrap {
  margin-top: 14px;
}
.data_contents {
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
}

.count {
  font-size: 20px;
  margin-left: 25px;
}

.confirm_address .confirm_wrap {
  margin-top: 27px;
}
.confirm_credit .confirm_wrap,
.confirm_deliveryFlag .confirm_wrap {
  margin-top: 24px;
}


.sum_wrap {
  margin-top: 25px;
  padding: 0 15px;
}
.sum_contents {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.sum_contents:last-child {
  border-bottom: 1px solid #C9C9C9;
  padding-bottom: 13px;
}
.sum_title {
  font-size: 14px;
}
.yen {
  font-size: 12px;
}
.sum_price {
  font-size: 16px;
}

.sum_total {
  padding-bottom: 48px;
}
.total_wrap {
  color: #009FA9;
  margin-top: 16px;
  text-align: right;
}

.total_wrap .total_price {
  font-size: 26px;
}

.total_wrap .yen {
  font-size: 20px;
}

.total_wrap .total_point {
  font-size: 12px;
  margin-top: 3px;
}
.total_wrap .point_score {
  font-size: 16px;
}
.total_wrap .point {
  font-size: 12px;
}
.complete {
  margin-top: 56px;
}

.confirm_coupon .edit {
  margin: 16px 0 0 auto;
}


</style>



// WEBPACK FOOTER //
// src/views/subscriptionMultiBc/Complete.vue